export default __webpack_public_path__ + "71f23c4b1ae26ff8de1ca58a9c502851.png";